import React from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
import classNames from 'classnames';

import style from './Scaleup.scss';

const Scaleup = ({ children, duration = 300, ...props }) => (
  <Transition timeout={duration} {...props}>
    {(state) => {
      const child = React.Children.only(children);
      return React.cloneElement(child, {
        className: classNames(child.props.className, style.scaleup, style[`scaleup--${state}`]),
        style: { animationDuration: `${duration}ms` },
      });
    }}
  </Transition>
);

Scaleup.propTypes = {
  children: PropTypes.node,
  duration: PropTypes.number,
};

Scaleup.defaultProps = {
  duration: 300,
};

export default Scaleup;
